import { render, staticRenderFns } from "./ImageDetails.vue?vue&type=template&id=2459a5f6&scoped=true"
import script from "./ImageDetails.vue?vue&type=script&lang=js"
export * from "./ImageDetails.vue?vue&type=script&lang=js"
import style0 from "./ImageDetails.vue?vue&type=style&index=0&id=2459a5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2459a5f6",
  null
  
)

export default component.exports